import * as yup from 'yup'
import type { Database } from '../types/supabase'
import {
  nullableNumberValidator,
  nullableStringValidator,
  commonFields,
  type InputType,
  type UploadType,
  type EmptyInputType,
  type UploadWithNewReferenceType,
} from './common'

type GerminationTable = Database['public']['Tables']['germination']['Insert']
export type GerminationTypes = {
  upload: GerminationUpload
  withNewReference: GerminationPreUpload
  input: GerminationInput
  emptyInput: EmptyGerminationInput
}

type GerminationUpload = UploadType<GerminationTable>

type GerminationInput = InputType<GerminationUpload>

type EmptyGerminationInput = EmptyInputType<GerminationInput>

type GerminationPreUpload = UploadWithNewReferenceType<GerminationUpload>

export const schema: yup.ObjectSchema<GerminationInput> = yup
  .object({
    ...commonFields,
    condition: nullableStringValidator,
    cultivar: nullableStringValidator,
    days: nullableStringValidator,
    light_hours: nullableStringValidator,
    medium: nullableStringValidator,
    msb_serial_number: nullableNumberValidator,
    msb_test_number: nullableNumberValidator,
    notes: nullableStringValidator,
    percent_germ: nullableStringValidator,
    presow_treatment: nullableStringValidator,
    sample_size: nullableNumberValidator,
    temperature: nullableStringValidator.transform((value: string) =>
      value.replaceAll('�C', '°C'),
    ),
  })
  .test(
    'reference-id-or-new-reference-exists',
    'Reference ID or new reference must be provided',
    function (value) {
      if (
        value.reference_id ??
        (value.new_reference_citation && value.new_reference_description)
      ) {
        return true
      }
      return false
    },
  )

export const germinationParser = async (data: GerminationInput) =>
  await schema.validate(data)
